export const checksums = {
  "content": "v3.5.0--viia3pDconOxbkTHQdq0lKLUYxR8_vJ2GlbNM9l10A0"
}
export const checksumsStructure = {
  "content": "56UIjV8ssPJnJ-BBEeeRpaYhT1umpBT13x12W-kJEsk"
}

export const tables = {
  "content": "_content_content",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "head": "json",
      "schemaOrg": "json",
      "robots": "json",
      "sitemap": "json",
      "icon": "string",
      "order": "number"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}